import { render, staticRenderFns } from "./CoffeeCard.vue?vue&type=template&id=ff24d3b4&"
import script from "./CoffeeCard.vue?vue&type=script&lang=js&"
export * from "./CoffeeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff24d3b4')) {
      api.createRecord('ff24d3b4', component.options)
    } else {
      api.reload('ff24d3b4', component.options)
    }
    module.hot.accept("./CoffeeCard.vue?vue&type=template&id=ff24d3b4&", function () {
      api.rerender('ff24d3b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/CoffeeCard.vue"
export default component.exports